import { render, staticRenderFns } from "./InterfaceName.vue?vue&type=template&id=118c61dc&scoped=true&"
import script from "./InterfaceName.vue?vue&type=script&lang=js&"
export * from "./InterfaceName.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceName.vue?vue&type=style&index=0&id=118c61dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c61dc",
  null
  
)

export default component.exports